
export default {
  name: "TableRowId",
  props: {
    model: [Number, String],
  },
};
